import React, { useEffect, useState } from 'react';
import API from '../services/api';

function TherapistDebtPage() {
  const [debtRecords, setDebtRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchDebtRecords();
  }, []);

  const fetchDebtRecords = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await API.get('/therapist/debt-records'); // new route in therapistRoutes
      setDebtRecords(res.data);
    } catch (err) {
      console.error('Error fetching debt records:', err);
      setError('Failed to load debt records.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '2rem' }}>
      <h2 style={{ marginBottom: '1rem' }}>Debt Sessions</h2>

      {loading && <p>Loading...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}

      {(!loading && debtRecords.length === 0) ? (
        <p>No debt sessions found.</p>
      ) : (
        <table
          border="1"
          cellPadding="5"
          style={{ borderCollapse: 'collapse', width: '100%' }}
        >
          <thead style={{ background: '#eee' }}>
            <tr>
              <th>Client</th>
              <th>Date</th>
              <th>Service</th>
              <th>Billed</th>
              <th>Collected</th>
              <th>Therapist Notes</th>
              <th>Admin Notes</th>
            </tr>
          </thead>
          <tbody>
            {debtRecords.map((record) => (
              <tr key={record.id}>
                <td>{record.client_name}</td>
                <td>{new Date(record.session_date).toLocaleDateString()}</td>
                <td>{record.service_type}</td>
                <td>${record.billed_amount}</td>
                <td>${record.collected_amount || 0}</td>
                <td>{record.therapist_notes || ''}</td>
                <td>{record.admin_notes || ''}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default TherapistDebtPage;
